// src/config/api.config.ts
export interface ApiConfig {
  baseUrl: string
  endpoints: {
    cameras: string
    clients: string
    users: string
    anprEvents: string
    ahcrEvemts: string
    anprAlarms: string
    auth: {
      login: string
      refresh: string
    }
  }
  timeout: number
}

const baseApiUrl: string = process.env.REACT_APP_API_BASE_URL ?? ''

const apiConfig: ApiConfig = {
  baseUrl: baseApiUrl,
  endpoints: {
    cameras: '/camera',
    clients: '/client',
    users: '/user',
    anprEvents: '/ANPREvent',
    ahcrEvemts: '/AHCREvent',
    anprAlarms: '/ANPRAlarm',
    auth: {
      login: '/auth/login',
      refresh: '/auth/refresh',
    },
  },
  timeout: 30000,
}

export default apiConfig
